import { PRODUCT_CARD_CLICKED } from '@/constants/product-events'
import Alpine from 'alpinejs'

document.addEventListener('alpine:init', () => {
  Alpine.data('productCard', (content) => ({
    accordionHeight: 0,

    eventItemClick() {
      this.$dispatch(PRODUCT_CARD_CLICKED, content)
    },

    eventMouseover() {
      if (!this.$refs?.accordionInner) return

      this.accordionHeight = this.$refs.accordionInner.offsetHeight

      this.$refs.accordion.style.setProperty(
        '--accordion-height',
        `${this.accordionHeight}px`,
      )
    },

    eventMouseleave() {
      if (!this.$refs?.accordionInner) return

      this.accordionHeight = 0

      this.$refs.accordion.style.setProperty(
        '--accordion-height',
        `${this.accordionHeight}px`,
      )
    },
  }))
})
